import type { Dispatch, SetStateAction } from 'react';
import { memo, useState } from 'react';
import CheckoutCommentDialog from '../CheckoutCommentDialog';
import DiscountDialog from './dialogs/DiscountDialog';
import EmptyCartDialog from './dialogs/EmptyCartDialog';
import WastageDialog from './dialogs/WastageDialog';
import OptionsContextMenu from './OptionsContextMenu';
import { useLocation } from '../../../../../context/LocationContext';
import SelectOpenBillButton from '../../OpenBillPicker/SelectOpenBillButton';
import BackButton from '../../../../../components/BackButton';
import { useNavigate } from 'react-router-dom';
import { useScreenSize } from '../../../../../context/ScreenSizeContext';

interface CartHeaderProps {
  openDiscountDialog: boolean;
  setOpenDiscountDialog: Dispatch<SetStateAction<boolean>>;
}

const CartHeader = (props: CartHeaderProps) => {
  const { openDiscountDialog, setOpenDiscountDialog } = props;
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [openWasteDialog, setOpenWasteDialog] = useState(false);
  const [openEmptyCartDialog, setOpenEmptyCartDialog] = useState(false);
  const { isDigitalBillEnabled } = useLocation();
  const navigate = useNavigate();
  const { isPhone } = useScreenSize();
  const { location } = useLocation();
  const shouldShowBillButton =
    isDigitalBillEnabled || location.deliveryMethods.find((method) => method.type === 'TABLE');

  return (
    <>
      <div className="flex justify-between w-full border-b border-1 border-grey-lightest">
        <div className="w-[85px] flex-shrink">
          {isPhone && <BackButton className="border-none" navigateTo={() => navigate(`/${location.locationId}`)} />}
        </div>
        {shouldShowBillButton && <SelectOpenBillButton />}
        <div className="w-[85px] flex justify-end flex-shrink items-center">
          <OptionsContextMenu
            setOpenWasteDialog={setOpenWasteDialog}
            setOpenEmptyCartDialog={setOpenEmptyCartDialog}
            setOpenDiscountDialog={setOpenDiscountDialog}
          />
        </div>
      </div>
      {openCommentDialog && (
        <CheckoutCommentDialog isOpen={openCommentDialog} setOpenCommentDialog={setOpenCommentDialog} />
      )}

      {openWasteDialog && <WastageDialog isOpen={openWasteDialog} setOpenWasteDialog={setOpenWasteDialog} />}
      {openEmptyCartDialog && (
        <EmptyCartDialog isOpen={openEmptyCartDialog} setOpenEmptyCartDialog={setOpenEmptyCartDialog} />
      )}
      {openDiscountDialog && <DiscountDialog onClose={() => setOpenDiscountDialog(false)} />}
    </>
  );
};

export default memo(CartHeader);
